import { initClient, initClientNavigation } from "rwsdk/client";
import { initSentry } from "./lib/sentry.js";
import * as Sentry from "@sentry/react";

// Initialize Sentry first
initSentry();

const { handleResponse, onHydrationUpdate } = initClientNavigation();
initClient({
  handleResponse,
  onHydrationUpdate,
  hydrateRootOptions: {
    onUncaughtError: (error, errorInfo) => {
      Sentry.captureException(error, {
        contexts: {
          react: {
            componentStack: errorInfo.componentStack,
            // @ts-expect-error - errorBoundary is not typed correctly
            errorBoundary: errorInfo.errorBoundary?.constructor.name,
          },
        },
        tags: { errorType: "uncaught" },
      });
    },
    onCaughtError: (error, errorInfo) => {
      Sentry.captureException(error, {
        contexts: {
          react: {
            componentStack: errorInfo.componentStack,
            errorBoundary: errorInfo.errorBoundary?.constructor.name,
          },
        },
        tags: { errorType: "caught" },
      });
    },
  },
});
